import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';

import AppForm from './AppForm';
import { flashErrorMessage } from '../actions/flash';
import { fetchHimsPostcodes } from '../actions/himsPostcodes';
import STATES from '../constants/states';

class SearchHimsPostcodes extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    state: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    himsPostcodes: PropTypes.shape({
      data: PropTypes.array,
    }),
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
  }
  static mapStateToProps = state => ({
    himsPostcodes: state.himsPostcodes,
  })
  static getPropsToState = (props) => {
    let value = props.value || '';
    const noResultsMessage = 'Loading...';

    const { himsPostcodes, state } = props;

    let postcodes = [];
    if (himsPostcodes && himsPostcodes.data && himsPostcodes.data.length > 0) {
      const srState = STATES.find(s => s.value === state);
      if (srState) {
        const himsState = himsPostcodes.data.find(hp => hp.id === srState.kod_negeri_id);
        if (himsState && himsState.postcodes) {
          postcodes = himsState.postcodes.map(p => ({
            key: p.poskod,
            value: p.poskod,
            kod_negeri_id: himsState.id,
            kod_bandar_id: p.kod_bandar_id,
            bandar: p.bandar,
            text: p.poskod,
          }));
        }
      } else {
        postcodes = himsPostcodes.data.flatMap(d =>
          (d.postcodes || []).map(postcode => ({
            key: postcode.poskod,
            value: postcode.poskod,
            kod_negeri_id: d.id,
            kod_bandar_id: postcode.kod_bandar_id,
            bandar: postcode.bandar,
            text: postcode.poskod,
          })),
        );
      }
    }

    // // add 'TIADA MAKLUMAT POSKOD' option if there isn't any
    // if (postcodes.length === 0) {
    //   postcodes.unshift({
    //     key: '0000000',
    //     value: '0000000',
    //     kod_negeri_id: null,
    //     kod_bandar_id: '0000',
    //     text: 'TIADA MAKLUMAT POSKOD',
    //   });
    // }

    if (postcodes.length > 0 && value) {
      const himsPostcode = postcodes.find(c => c.value === value);
      if (!himsPostcode) {
        value = '';
      }
    }

    return {
      value,
      noResultsMessage,
      postcodes,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchHimsPostcodes.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentDidMount() {
    const { store } = this.context;
    store.dispatch(fetchHimsPostcodes(false))
      .catch(err => store.dispatch(flashErrorMessage(err)));
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchHimsPostcodes.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, data) => {
    let { value } = data;
    const postcode = this.state.postcodes.find(c => c.value === value);
    if (!postcode) {
      value = '';
    }
    this.setState({ value }, () => {
      if (postcode && this.props.onSelect) {
        this.props.onSelect(postcode);
      }
    });
  }
  render() {
    const { name } = this.props;
    const { postcodes, value } = this.state;
    return (
      <AppForm.Validate
        ref={this.props.validateRef}
        validation={[required]}
        onChange={this.handleOnChange}
        validateLabel="Postcode"
      >
        <Form.Select
          name={name}
          fluid
          options={postcodes}
          placeholder="Postcode*"
          label="Postcode*"
          search
          selectOnBlur={false}
          value={value}
        />
      </AppForm.Validate>
    );
  }
}

export default connect(SearchHimsPostcodes.mapStateToProps)(SearchHimsPostcodes);



// WEBPACK FOOTER //
// ./src/components/SearchHimsPostcodes.jsx